import React, { useState, useEffect, useCallback } from 'react';
import CardBase from './CardBase';
import Content from './Content';
import FlattenTree from '../../utils/FlattenTree';
import Sider from './Sider';
import ProcessoService from '../../services/ProcessoService';
import useActionCableMultiplos from '../../hooks/useActionCableMultiplos';
import Sleep from '../../utils/Sleep';

const index = ({processo_tree: processoTree, user_id: userId}) => {
  // CONFIG STATES
  const [processamentos, setProcessamentos]             = useState([]);
  const [currentProcessamento, setCurrentProcessamento] = useState(null);
  const [processosAnos, setProcessosAnos]               = useState([]);
  const [loading, setLoading]                           = useState(false);
  const {received}                                      = useActionCableMultiplos('LogProcessamentoSoMultiplosChannel', userId, processosAnos);

  // HANDLE INIT PROCESSAMENTO MATERIALIZAR
  const handleInitProcessamento = useCallback(async (bool) => {
    if (bool === true && !currentProcessamento) {
      try {
        const processoRaiz = processamentos.find((item) => item.tipo === 'raiz');
        if (processoRaiz) {
          setLoading(true);
          const numero_ano = processoRaiz.numero.replace('/', '_');
          // await Sleep(500);
          const response   = await ProcessoService.processar_ape_inc_folder_so_processo(numero_ano);
          if (response.status != 200) {
            throw(response.data.message);
          }
        }
      } catch (e) {
        setLoading(false);
      }
    }
  }, [currentProcessamento, processamentos]);

  // CONFIG PROCESSAMENTOS AND ACTION CABLE
  useEffect(() => {
    if (processoTree) {
      const result = FlattenTree(processoTree);
      if (result.length > 0) {
        const processosAnos = result.map((item) => item.numero.replace('/', '_'));
        setProcessosAnos(processosAnos);
      }
      setProcessamentos(result);
    }
    return () => {};
  }, [processoTree]);


  // EFFECT RECEIVED ACTION CABLE
  useEffect(() => {
    if (received) {
      setCurrentProcessamento(received.currentProcessamento);
      if (loading === true) setLoading(false);

      if (received?.currentProcessamento?.status === 'finish') {
        (async () => {
          await Sleep(4000);
          Turbolinks.visit(location.toString());
        })();
      }
    }
    return () => {};
  }, [received, loading]);

  return (
    <CardBase numeroProcesso={processoTree.numero}
              started={!!currentProcessamento}
              finished={currentProcessamento?.status === 'finish'}>
      <Sider processamentos={processamentos} handleCurrentProcessamento={currentProcessamento} />

      <Content
        handleInitProcessamento={handleInitProcessamento}
        handleCurrentProcessamento={currentProcessamento}
        loading={loading}
        userId={userId} />
    </CardBase>
  );
};

export default index;
